import { useEffect, useState } from 'react';
import AppWrappedDropdown from '../../AppWrappedDropdown';
import { fetchUserCredentialData } from '../../79/_api';

/**
 * User Credential input component for Epic/EpicCare stylized to work with Custom App Request Form
 * @param {Object} props component properties
 * @returns Custom input
 */
const UserCredentialField = props => {
	const [loadingStatus, setLoadingStatus] = useState(true);
	const [optionsList, setOptionsList] = useState([]);
	useEffect(() => {
		fetchUserCredentialData()
			.then(response => {
				setOptionsList(response);
				setLoadingStatus(false);
			})
			.catch(e =>
				props.formik.setStatus({
					error: {
						source: props.name,
						cause: 'API Failure',
						details: e,
						message:
							'Unable to retrieve credentials for the dropdown.  Please try again.',
					},
				})
			);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<AppWrappedDropdown
			label={"User's Credentials"}
			options={optionsList}
			isLoading={loadingStatus}
			noValueOverride={'N/A'}
			{...props}
		/>
	);
};

export default UserCredentialField;
